var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-detail',{attrs:{"model":_vm.model}})}
var staticRenderFns = []

export { render, staticRenderFns }